var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErodeMarkNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24.9687 23.9993",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9687 12.3095C24.9687 17.7724 21.3656 22.3824 16.3995 23.9993C16.3831 23.9747 16.3634 23.9513 16.341 23.9286C15.4024 22.9333 14.1715 20.9102 16.5461 18.4917C21.4005 13.5595 16.036 13.3508 13.3361 11.9763C9.998 10.3122 14.0807 8.8541 15.5169 6.50497C16.9522 4.15584 14.5027 4.56022 14.5027 4.56022C14.5027 4.56022 16.9674 4.82073 11.9992 7.67337C7.03114 10.526 7.39789 13.4447 8.82018 14.1175C10.4935 14.9113 13.0634 15.6695 8.39496 19.2278C7.10019 20.22 6.20044 21.4091 5.57602 22.562C2.2195 20.3593 0 16.5968 0 12.3095C0 5.53486 5.61344 0 12.4843 0C19.3551 0 24.9687 5.53486 24.9687 12.3095Z",
    fill: "var(--fill-0, #A2BBBF)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErodeMarkNew);
export default __webpack_public_path__ + "static/media/erode-mark-new.27d067eb207e51be659d0f9819e02441.svg";
export { ForwardRef as ReactComponent };